import { Typography, TypographyProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

export interface TextProps extends Omit<TypographyProps, 'sx'> {
  children?: ReactNode;
  size?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  weight?: number | string;
  color?: TypographyProps['color'];
  sx?: SxProps<Theme>;
}

export function Text({
  children,
  size,
  weight,
  color,
  sx,
  ...props
}: TextProps) {
  const getResponsiveFontSize = () => {
    if (!size) return undefined;

    return {
      xs: size.xs ? `${size.xs}px` : undefined,
      sm: size.sm ? `${size.sm}px` : undefined,
      md: size.md ? `${size.md}px` : undefined,
      lg: size.lg ? `${size.lg}px` : undefined,
      xl: size.xl ? `${size.xl}px` : undefined,
    };
  };

  return (
    <Typography
      sx={{
        fontSize: getResponsiveFontSize(),
        fontWeight: weight,
        color: color,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export const TextMd = (props: TypographyProps) => {
  return <Text fontWeight={500} {...props} />;
};

export default Text;
